import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './components/landing/landing.component';
import { ProductsComponent } from './components/products/products.component';
import { PaymentComponent } from './components/payment/payment.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { CrewVoucherComponent } from './components/crew-voucher/crew-voucher.component';

const appRoutes: Routes = [
    { path: 'product', component: ProductsComponent},
    { path: 'payment', component: PaymentComponent},
    { path: 'buywifi/confirmation', component: ConfirmationComponent},
    { path: 'buywifi/product', component: ProductsComponent},
    { path: 'buywifi/payment', component: PaymentComponent},
    { path: 'confirmation', component: ConfirmationComponent},
    { path: ':pos/home', component: LandingComponent },
    { path: 'home', component: LandingComponent },
    { path: 'home/voucher', component: CrewVoucherComponent },
    { path: '', redirectTo: 'home', pathMatch: 'full'}
];
@NgModule({
    imports: [
        RouterModule.forRoot(
            appRoutes, {
                 useHash: true
            }
        )
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }

